import { render } from "./CVBase.vue?vue&type=template&id=2c38ca6f"
import script from "./CVBase.vue?vue&type=script&lang=js"
export * from "./CVBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Dashboard/CVBase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c38ca6f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c38ca6f', __exports__)) {
    api.reload('2c38ca6f', __exports__)
  }
  
  module.hot.accept("./CVBase.vue?vue&type=template&id=2c38ca6f", () => {
    api.rerender('2c38ca6f', render)
  })

}


export default __exports__